import anime from 'animejs';

const duration = 200;
const activeClass = 'is-open-card';

export function initSelectCardSubscription() {
    const toggles = document.querySelectorAll('[data-card]');
    if (!toggles.length) return;

    toggles.forEach((toggle) => {
        const input = toggle.querySelector('.radio-input-v1__input');

        if (toggle.classList.contains(activeClass)) {
            openCard(toggle);
            checkTabIndex(toggle);
        }

        toggle.addEventListener('click', handleOnClick, false);
        input.addEventListener('keydown', handleOnKeyDown, false);
    });
}

function handleOnKeyDown(event) {
    if (event.key === 'Enter' && event.currentTarget.tagName === 'INPUT') {
        const card = event.currentTarget.closest('[data-card]');

        checkTabIndex(card);
        toggleClassActive(card);
    }
}

function handleOnClick(event) {
    const card = this.closest('[data-card]');
    const isOpen = card.classList.contains(activeClass);

    if (event.target.type === 'submit' || event.target.className === 'radio-input-v1__fake-radio') {
        return;
    }

    checkTabIndex(card);
    toggleClassActive(card);
}

function openCard(card) {
    const input = card.querySelector('[data-input]');
    const body = card.querySelector('[data-card-body]');
    const height = body.scrollHeight;

    input.checked = true;
    card.classList.add(activeClass);

    anime({
        targets: body,
        height: [0, height],
        easing: 'linear',
        duration: duration,
    });
}

function closeCard(card) {
    const body = card.querySelector('[data-card-body]');
    const input = card.querySelector('[data-input]');
    const height = body.scrollHeight;
    body.style.height = `${height}px`;
    card.classList.remove(activeClass);
    input.checked = false;

    anime({
        targets: body,
        height: 0,
        easing: 'linear',
        duration: duration,
    });
}

function checkTabIndex(card) {
    const formButton = card.querySelector('[data-form-btn]');
    const input = card.querySelector('[data-input]');

    input.checked ? formButton.setAttribute('tabindex', '0') : formButton.setAttribute('tabindex', '-1');
}

function toggleClassActive(card) {
    const isOpen = card.classList.contains(activeClass);
    const openCards = document.querySelectorAll(`[data-card].${activeClass}`);

    if (isOpen) {
        closeCard(card);
    } else {
        openCard(card);
        openCards.forEach((openCard) => {
            if (openCard !== card) {
                closeCard(openCard);
            }
        });
    }
}
